import { Injectable } from "@angular/core";
import { BaseStyle } from "primeng/base";
import { Ankaadia } from "../../../theme/preset";

@Injectable({ providedIn: "root" })
export class SidenavItemStyle extends BaseStyle {
  override name = "sidenavitem";

  override theme = ({ dt }: any): string => `
    .ui-sidenavitem {
      display: block;
    }

    .ui-sidenavitem-link {
      display: flex;
      align-items: center;
      user-select: none;
      cursor: pointer;
      color: ${dt("sidenav.link.color")};
      gap: ${dt("sidenav.link.gap")};
      padding: ${dt("sidenav.link.padding")};
      border-radius: ${dt("sidenav.link.border.radius")};
      line-height: ${dt("sidenav.link.font.leading")};
    }

    .ui-sidenavitem-link:hover,
    .ui-sidenavitem-active .ui-sidenavitem-link,
    .ui-sidenavpanel-active > .ui-sidenavheader > .ui-sidenavitem .ui-sidenavitem-link {
      background: ${dt("sidenav.link.hover.background")};
      color: ${dt("sidenav.link.hover.color")};
    }

    .ui-sidenavitem-icon {
      color: ${dt("sidenav.icon.color")};
      font-size: ${dt("sidenav.icon.font.size")};
    }

    .ui-sidenavitem-label {
      color: ${dt("sidenav.label.color")};
      font-weight: ${dt("sidenav.label.font.weight")};
    }

    /* pre-bold so that there's no layout shift */
    .ui-sidenavitem-label::after {
      content: attr(data-label);
      display: block;
      font-weight: ${dt("sidenav.label.hover.font.weight")};
      overflow: hidden;
      visibility: hidden;
      height: 0;
    }

    .ui-sidenavitem-link:hover .ui-sidenavitem-icon,
    .ui-sidenavitem-active .ui-sidenavitem-icon,
    .ui-sidenavpanel-active > .ui-sidenavheader > .ui-sidenavitem .ui-sidenavitem-icon {
      color: ${dt("sidenav.icon.hover.color")};
    }

    .ui-sidenavitem-link:hover .ui-sidenavitem-label,
    .ui-sidenavitem-active .ui-sidenavitem-label,
    .ui-sidenavpanel-active > .ui-sidenavheader > .ui-sidenavitem .ui-sidenavitem-label {
      color: ${dt("sidenav.label.hover.color")};
      font-weight: ${dt("sidenav.label.hover.font.weight")};
    }
    
    @media (width < ${Ankaadia.semantic.breakpoint.laptop}) {
      .ui-sidenavheader .ui-sidenavitem-label {
        display: none !important;
      }
    }

    @media (width < ${Ankaadia.semantic.breakpoint.mobile}) {
      .ui-sidenavheader .ui-sidenavitem-link {
        flex-direction: column;
      }

      .ui-sidenavpanel .ui-sidenavpanel .ui-sidenavheader .ui-sidenavitem-link {
        flex-direction: row;
      }

      .ui-sidenavheader .ui-sidenavitem-label {
        display: block !important;
        font-size: ${dt("sidenav.label.mobile.font.size")};
        line-height: ${dt("sidenav.label.mobile.font.leading")};
        font-weight: ${dt("sidenav.label.mobile.font.weight")};
      }

      .ui-sidenavpanel .ui-sidenavpanel .ui-sidenavheader .ui-sidenavitem-label {
        font-weight: ${dt("sidenav.label.font.weight")};
        font-size: ${dt("sidenav.label.font.size")};
      }
    }
  `;

  override classes = {
    root: ({ instance }: any): Record<string, boolean> => ({
      "ui-sidenavitem": true,
      "ui-sidenavitem-active": instance.active(),
    }),
    active: "ui-sidenavitem-active",
    link: "ui-sidenavitem-link",
    icon: "ui-sidenavitem-icon",
    label: "ui-sidenavitem-label",
    tooltip: "ui-sidenavitem-tooltip",
  };
}
